import { render, staticRenderFns } from "./Integracoes.vue?vue&type=template&id=362854d9&scoped=true&"
import script from "./Integracoes.vue?vue&type=script&lang=js&"
export * from "./Integracoes.vue?vue&type=script&lang=js&"
import style0 from "./Integracoes.vue?vue&type=style&index=0&id=362854d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362854d9",
  null
  
)

export default component.exports